var baseClassName = 'fi-chip';
var chipClassNames = {
  disabled: "".concat(baseClassName, "--disabled"),
  content: "".concat(baseClassName, "--content")
};

export { baseClassName, chipClassNames };
//# sourceMappingURL=BaseChip.js.map
